<template>
  <div>
    <div class="action-bar"></div>
    <div class="stats">
      <div class="stat">
        <div class="stat-label">
          <span>Active</span>
          <img src="@/assets/icons/info_light.svg" alt="info" v-tooltip="{content: info_text.active, delay: 200}" />
        </div>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div style="position: relative; white-space: nowrap;">
            <h3>{{ formatCurrency(spendSummary.activeSpend || 0) }}</h3>
          <div style="position: absolute; width: 100%; text-align: center; bottom: -18px;">
            <span>{{ `(${spendSummary.countActive} Projects)` }}</span>
          </div>
          </div>
        </div>
      </div>

      <div class="stat">
        <div class="stat-label">
          <span>Completed</span>
          <img src="@/assets/icons/info_light.svg" alt="info" v-tooltip="{content: info_text.completed, delay: 200}" />
        </div>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div style="position: relative; white-space: nowrap;">
            <h3>{{ formatCurrency(spendSummary.completedSpend || 0) }}</h3>
            <div style="position: absolute; width: 100%; text-align: center; bottom: -18px;">
              <span>{{ `(${spendSummary.countCompleted} Projects)` }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="stat">
        <div class="stat-label">
          <span>Forecasted</span>
          <img src="@/assets/icons/info_light.svg" alt="info" v-tooltip="{content: info_text.forecasted, delay: 200}" />
        </div>
        <h3>{{ formatCurrency(spendSummary.forecastedBenefits || 0) }}</h3>
      </div>

      <div class="stat">
        <div class="stat-label">
          <span>Realised</span>
          <img src="@/assets/icons/info_light.svg" alt="info" v-tooltip="{content: info_text.realised, delay: 200}" />
        </div>
        <h3>{{ formatCurrency(spendSummary.realisedBenefits || 0) }}</h3>
      </div>

      <div class="stat">
        <div class="stat-label">
          <span>Benefits/Spend</span>
          <img src="@/assets/icons/info_light.svg" alt="info" v-tooltip="{content: info_text.benefitsToSpend, delay: 200}" />
        </div>
        <h3>{{ `${(spendSummary.benefitsToSpend * 100).toFixed(2)}%` }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import currency from '../../utils/currency';
import { mapGetters } from 'vuex';
export default {
  props: ['spendSummary', "yearEnding"],
  data() {
    return {
      filters: {
        teamMembers: ['All'],
        status: ['All'],
        categoryId: ['All'],
        type: ['All'],
      },
    };
  },
  methods: {
    formatCurrency(num) {
      if (!this.app_user) {
        return '0';
      }
      currency.locale(
        this.currencyCodeById(this.app_user.organization.currencyId)
      );
      return currency(num).format('$0a.[0]');
    },
    toggleMyUser(bool) {
      this.filters.teamMembers = bool ? [this.app_user.id] : ['All'];
    },
  },
  computed: {
    ...mapGetters(['currencyCodeById']),
    app_user() {
      return this.$store.getters.app_user;
    },
    info_text() {
      const fyText = this.yearEnding ? ' captured in the selected financial year' : '';
      return {
        active: `Total spend of active projects${fyText}`,
        completed: `Total spend of completed projects${fyText}`,
        forecasted: `Total forecasted savings${fyText}`,
        realised: `Total realised savings${fyText}`,
        benefitsToSpend: `Ratio of total realised benefits to total active and completed project spend${fyText}`,
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import './../../styles/_styles.scss';

.action-bar {
  display: flex;
  justify-content: flex-end;
}

.stats {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 !important;

  @media screen and (max-width: 1120px) {
    flex-direction: column;
    max-height: 700px;
  }
  .stat {
    flex: 1;
    border-right: 1px solid $panel-border-color;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 30px 10px;

    &:nth-child(5) {
      border-right: none;
    }

    @media screen and (max-width: 1120px) {
      border: none;
      margin: 20px 10px;
    }

    span {
      color: #c2c7d4;
      font-size: 13px;
      font-weight: 500;
    }

    .stat-label {
      display: flex;
      align-items: center;

      span {
        text-transform: uppercase;
        font-size: 16px;
      }

      img {
        margin-left: 5px; // Adjust as needed
        width: 20px;
        height: 20px;
      }
    }

    h3 {
      font-size: 38px;
      color: #26292f;
      font-weight: 500;
      margin: 0;
      text-align: center;
      min-width: 100px;
    }
  }
}

.floating {
  margin-top: 1px;
  margin-right: 2px;
  position: absolute;
  top: 0;
  right: 0;
}

.toggle {
  justify-content: start;
  margin: 20px 0 0 0;
}
</style>
